import React from 'react';
import {FormattedMessage} from 'react-intl';
import cn from 'classnames';

import './styles.scss';

export type FavoritesTab = 'all' | 'library' | 'resource';

type Props = {
  active: FavoritesTab;
  onChange: (tab: FavoritesTab) => void;
}

const TABS: {key: FavoritesTab; id: string; defaultMessage: string}[] = [
  {key: 'all', id: 'gritx.backpack.tabs.all', defaultMessage: 'All'},
  {key: 'library', id: 'gritx.backpack.tabs.library', defaultMessage: 'Library'},
  {key: 'resource', id: 'gritx.backpack.tabs.resource', defaultMessage: 'Resource'}
];

export const FavoritesTabs = ({active, onChange}: Props): JSX.Element => {
  return (
    <div className="favorites-tabs" role="tablist">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={active === tab.key}
          className={cn('favorites-tabs__tab', {'favorites-tabs__tab--active': active === tab.key})}
          onClick={() => onChange(tab.key)}
        >
          <FormattedMessage id={tab.id} defaultMessage={tab.defaultMessage}/>
        </button>
      ))}
    </div>
  );
};
